/**
 * xiaoxia
 */


import React, {Component} from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import {Mask} from 'react-weui';
import {renderMoney} from '../utils';


import '../styles/AvailableCoupon.css';


class AvailableCoupon extends Component {
    constructor(){
        super()
        this.onUse = this.onUse.bind(this)
    }

    componentDidMount(){
        const {scope, target} = this.props
        const coupon = JSON.parse(localStorage.getItem('lastCoupon'))
        if(coupon) {
            const object_id = coupon.lecture_id || coupon.channel_id || coupon.liveroom_id
            if(object_id === target.id){
                this.props.dispatch({
                    type: 'COUPON_SET_AVAILABLE',
                    payload: {
                        coupon: coupon
                    }
                })
            }
        }
    }

    onUse(){
        const {scope} = this.props
        const coupon = this.props.availableCoupon
        if(scope === 'lecture'){
            this.props.dispatch({
                type: 'LECTURE_SET_DISCOUNT',
                payload: coupon
            });
            this.props.dispatch({
                type: 'LECTURE_SHOW_DISCOUNT_PAY_PANEL'
            });
        }else if(scope === 'channel'){
            this.props.dispatch({
                type: 'CHANNEL_SET_DISCOUNT',
                payload: coupon
            });
            this.props.dispatch({
                type: 'CHANNEL_SHOW_PAY_PANEL'
            });
        }
    }

    render() {
        const coupon = this.props.availableCoupon
        if(!coupon)
            return null

        return(
            <div className="available-coupon">
                <div className="tips text-ellipsis">
                    你有一张面值 ¥{renderMoney(coupon.price)} 的优惠券可以使用
                </div>
                <button className="use-btn" onClick={this.onUse}>使用</button>
            </div>
        )
    }
}


export default connect((state) => ({
    availableCoupon: state.coupon.availableCoupon
}))(AvailableCoupon)




// WEBPACK FOOTER //
// ./src/components/AvailableCoupon.js